export enum EMenuButtonType {
  Toggle,
  Checkbox,
  Radio,
}
